import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { DsaScheduleEventDto } from "../../generated/dashboard-client";
import "./ConfirmationModal.scss";

export interface DeleteScheduleEventModalProps {
  event: DsaScheduleEventDto | null;
  isVisible: boolean;
  deleteEvent: (eventId: string) => void;
  onClose: () => void;
}

export function DeleteScheduleEventModal({
  event,
  isVisible,
  deleteEvent,
  onClose,
}: DeleteScheduleEventModalProps) {
  const [saving, setSaving] = useState(false);

  function remove() {
    setSaving(true);
    deleteEvent(event!.id!);
  }

  useEffect(() => {
    if (!isVisible) {
      setSaving(false);
    }
  }, [isVisible])

  return (
    <Modal
      className={"confirmation-modal clean"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This will permanently delete this event.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={saving}
        >
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
